/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgradetobusinessdescription3Inputs */

const en_upgradetobusinessdescription3 = /** @type {(inputs: Upgradetobusinessdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Pulsify account stays as it is. You set up your profile right after.`)
};

const de_upgradetobusinessdescription3 = /** @type {(inputs: Upgradetobusinessdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Pulsify-Konto bleibt, wie es ist. Dein Profil richtest du gleich danach ein.`)
};

/**
* | output |
* | --- |
* | "Your Pulsify account stays as it is. You set up your profile right after." |
*
* @param {Upgradetobusinessdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const upgradetobusinessdescription3 = /** @type {((inputs?: Upgradetobusinessdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgradetobusinessdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgradetobusinessdescription3(inputs)
	return de_upgradetobusinessdescription3(inputs)
});
export { upgradetobusinessdescription3 as "upgradeToBusinessDescription" }